// extracted by mini-css-extract-plugin
export default {"notificationCard":"NotificationCard_notificationCard__vjAuk"};